// extracted by mini-css-extract-plugin
module.exports = {"Input":"OffSiteStockingItemInput_Input__3W7Eg"};